import classNames from 'classnames'

export default function ProgressBar({
  progress,
  progressBarClassname,
}: {
  progress: number
  progressBarClassname?: string
}) {
  let progressPercentaje = 0
  if (progress < 0) {
    progressPercentaje = 0
  } else if (progress >= 100) {
    progressPercentaje = 100
  } else progressPercentaje = progress
  return (
    <div className="h-[8px] w-full rounded-[4px] bg-surface-muted">
      <div
        className={classNames(`h-[8px] rounded-[4px] bg-blue-600`, progressBarClassname)}
        style={{ width: `${progressPercentaje}%` }}
      ></div>
    </div>
  )
}
